import { formatTitle } from "../../../utils/FormatTitle";

const NavMarker = ({ route }) => {
  return (
    <ol className="topbar-title">
      <li>
        <a className="breadCrumb-item">
          <span> {process.env.REACT_APP_NAVMARKER_PARENTNAME}</span>
        </a>
      </li>
      <li>
        <a className="breadCrumb-item leaf">
          <span>{formatTitle(route)}</span>
        </a>
      </li>
    </ol>
  );
};

export default NavMarker;
